import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    searchFacetChange,
    toggleVisibleDropdownMenu,
} from '../Actions/FacetedSearch.action';

const FacetedSearchCompact = ({ facetFilters, onFacetChange }) => {
    const dispatch = useDispatch();
    const { visibleDropdownMenu } = useSelector((state) => state.facetedSearch);

    const menuRef = useRef(null);
    const activeSublistRef = useRef(null); 

    useEffect(() => {
        const handleClickOutside = (event) => {
            // If click is outside the menu or outside the active sublist
            if (
                menuRef.current && 
                (!menuRef.current.contains(event.target) || 
                    (activeSublistRef.current && 
                        !activeSublistRef.current.contains(event.target))) 
            ) {
                dispatch(toggleVisibleDropdownMenu({ id: null }));
            }
        };

        document.addEventListener('click', handleClickOutside);

        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, [dispatch]);

    const handleGroupClick = (group) => {
        if (visibleDropdownMenu.includes(group.id)) {
            dispatch(toggleVisibleDropdownMenu({ id: null }));
        } else {
            dispatch(toggleVisibleDropdownMenu(group));
        }
    };

    return (
        <ul className="faceted-search faceted-search--compact row" ref={menuRef}>
            {facetFilters &&
                facetFilters.map((group, groupIndex) =>
                    group.options && group.options.length > 0 ? (
                        <li
                            className="columns small-6 large-3 faceted-search__group"
                            key={`${group.label}-${groupIndex}`}
                        >
                            <div
                                className={`faceted-search__group-header ${visibleDropdownMenu.includes(group.id)
                                    ? 'faceted-search__group-header--show-compact'
                                    : ''
                                    }`}
                                role="faceted-search-item-group"
                                onClick={(event) => {
                                    event.stopPropagation();
                                    handleGroupClick(group);
                                }}
                            >
                                {group.label}
                            </div>

                            {visibleDropdownMenu.includes(group.id) && (
                                <ul
                                    className="faceted-search__sublist"
                                    ref={activeSublistRef}
                                >
                                    {group.options.map((item, itemIndex) => (
                                        <li
                                            key={`${item.label}-${itemIndex}`}
                                            className="faceted-search__item"
                                            role="faceted-search-item"
                                        >
                                            <FacetedFilterCheckbox
                                                item={item}
                                                group={group}
                                            />
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </li>
                    ) : null
                )}
        </ul>
    );
};

const FacetedFilterCheckbox = ({ item, group }) => {
    const dispatch = useDispatch();
    const onChange = (group, item) => dispatch(searchFacetChange(group, item));

    return (
        <label className="faceted-filter">
            <input
                className="faceted-filter__input"
                type="checkbox"
                onChange={() => onChange(group, item)}
                checked={group.selectedOptions.includes(item.id)}
            />
            <span className="faceted-filter__label">
                {item.label}
                {!isNaN(item.quantity) && item.quantity > 0 && (
                    <span className="faceted-filter__quantity">
                        {' '}
                        ({item.quantity})
                    </span>
                )}
            </span>
        </label>
    );
};

export default FacetedSearchCompact;
